export const getYear = state => state.reportCostCenterCosts.getIn(['list', 'year'])

export const getData = state => state.reportCostCenterCosts.getIn(['list', 'data'])
export const getFetching = state => state.reportCostCenterCosts.getIn(['list', 'fetching'])
export const getError = state => state.reportCostCenterCosts.getIn(['list', 'error'])

export const getDetailsData = state => state.reportCostCenterCosts.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportCostCenterCosts.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportCostCenterCosts.getIn(['details', 'error'])
